import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { format, parse, isValid, toDate } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import { useGetShiftSheduleQuery } from "AppQuries/shift/schedule/scheduler";
import moment from "moment";
import { useGetProjectsQuery } from "AppQuries/project/project";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
const options = [
  { id: 0, label: "Absent", value: 0 },
  // { id: 1, label: "Half Day", value: 0.5 },
  { id: 2, label: "Present", value: 1 },
];

const Attendance = ({ mode = "I", onSubmit, show = false, handleClose }) => {
  const userData = useSelector(loggedInUser);
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useFormContext();
  const companyCode = watch("companyCode");
  const employeeCode = watch("employeeCode");
  const attendanceDate =
    watch("attendanceDate") || format(new Date(), "yyyy-MM-dd");
  const locationCode = watch("locationCode");

  const { data: employees } = useGetEmployeeQuery({
    companyCode,
    locationCode,
  });

  const employeeOptions =
    employees
      ?.filter((emp) => emp.isActive)
      ?.map((emp) => ({
        id: emp.employeeCode,
        label: emp.fullName,
        value: emp.employeeCode,
      })) || [];

  const { data: scheduleData, refetch: refetchScheduleData } =
    useGetShiftSheduleQuery(
      {
        companyCode,
        locationCode,
        employeeCode,
        fromDate: attendanceDate,
        toDate: attendanceDate,
      },
      {
        enabled: !!employeeCode && !!attendanceDate,
      }
    );

  console.log(scheduleData);

  const { data: projects } = useGetProjectsQuery({
    isTrue: true,
    companyCode,
    locationCode,
  });

  const projectsOptions = Array.isArray(projects)
    ? projects
        ?.filter((r) => r.isActive === true)
        .map((r) => ({ label: r.projectName, value: r.projectCode }))
    : [];

  useEffect(() => {
    if (scheduleData?.length) {
      const schedule = scheduleData[0];
      console.log(schedule)
      const attendaceDay = format(
        new Date(attendanceDate),
        "EEEE"
      ).toLocaleLowerCase();
      console.log("Open Time", userData[`${attendaceDay}OpenTime`]);
      console.log("Close Time", userData[`${attendaceDay}CloseTime`]);
      setValue("scheduleId", schedule.scheduleId || 0);
      setValue(
        "inTime",
        moment(schedule.shiftInTimeStr, ["HH:mm"]).format("HH:mm") ||
          userData[`${attendaceDay}OpenTime`]
      );
      setValue(
        "outTime",
        moment(schedule.shiftOutTimeStr, ["HH:mm"]).format("HH:mm") ||
          userData[`${attendaceDay}CloseTime`]
      );
    }
  }, [scheduleData, setValue]);

  useEffect(() => {
    if (employeeCode && attendanceDate) {
      const attendaceDay = format(
        watch("attendanceDate")
          ? new Date(watch("attendanceDate"))
          : new Date(),
        "EEEE"
      ).toLocaleLowerCase();
      setValue("scheduleId", 0);
      setValue("attendanceValue", 1);
      setValue(
        "inTime",
        userData[`${attendaceDay}OpenTime`] || userData?.companyOpenTime
      );
      setValue(
        "outTime",
        userData[`${attendaceDay}CloseTime`] || userData?.companyCloseTime
      );
      refetchScheduleData();
    }
  }, [employeeCode, attendanceDate, refetchScheduleData]);

  return (
    <Modal show={show} onHide={handleClose} animation centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Attendance" : "Edit Attendance"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row row">
            <div className="col-12 mb-3">
              <Input
                name="employeeCode"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.employeeCode ? "is-invalid" : ""
                }`}
                label="Employee"
                labelClassName="form-label"
                optionData={employeeOptions}
                required
                onChange={(selectedOption) => {
                  setValue(
                    "employeeCode",
                    selectedOption ? selectedOption : null
                  );
                  trigger("employeeCode");
                }}
                requiredMessage="Employee is required"
                defaultValue={watch("employeeCode")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="col-12 mb-3">
              <Input
                name="attendanceDate"
                type="date"
                placeholder="Select Attendance Date"
                className={`form-control ${
                  errors.attendanceDate ? "is-invalid" : ""
                }`}
                label="Attendance Date"
                labelClassName="form-label"
                required={true}
                requiredMessage="Attendance Date is required"
                dateFormat="YYYY-MM-DD"
                defaultValue={attendanceDate}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="col-12 mb-3">
              <Input
                name="attendanceValue"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.attendanceValue ? "is-invalid" : ""
                }`}
                label="Attendance Value"
                labelClassName="form-label"
                optionData={options}
                required={true}
                requiredMessage="Attendance Value is required"
                onChange={(selectedOption) => {
                  setValue(
                    "attendanceValue",
                    selectedOption ? selectedOption : null
                  );
                  trigger("attendanceValue");
                }}
                defaultValue={watch("attendanceValue")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="col-12 mb-3">
              <Input
                name="projectId"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.projectId ? "is-invalid" : ""
                }`}
                label="Project"
                labelClassName="form-label"
                optionData={projectsOptions}
                required={false}
                requiredMessage="Project is required"
                onChange={(selectedOption) => {
                  setValue("projectId", selectedOption ? selectedOption : null);
                  trigger("projectId");
                }}
                defaultValue={watch("attendanceValue")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="col-6 mb-3">
              <Input
                name="inTime"
                type="time"
                placeholder="In Time"
                className={`form-control ${errors.inTime ? "is-invalid" : ""}`}
                label="In Time"
                labelClassName="form-label"
                required={true}
                requiredMessage="In Time is required"
              />
            </div>

            <div className="col-6 mb-3">
              <Input
                name="outTime"
                type="time"
                placeholder="Out Time"
                className={`form-control ${errors.outTime ? "is-invalid" : ""}`}
                label="Out Time"
                labelClassName="form-label"
                required={true}
                requiredMessage="Out Time is required"
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-submit">
              Add Attendance
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

Attendance.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default Attendance;
